import { getAccessToken, getLiteCompanyId } from "../../../../../actions/utils";
import { toast } from "react-toastify";
import axios from "axios";
import { getUrl } from "../../../../../actions/urls";

export const fetchCampaigns = async () => {
    try {
        const companyId = getLiteCompanyId();
        const response = await axios.get(`${getUrl("campaign_list")}`, {
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });
        const data = response.data;

        if (response.status === 200) {
            return data.data.campaigns;
        } else {
            throw new Error("Failed to fetch campaign: " + data.error);
        }
    } catch (error) {
        throw new Error("Failed to fetch campaign: " + error);
    }
};

export const deleteCampaign = async (campaignId) => {
    try {
        const response = await axios.delete(`${getUrl("campaign_url")}/${campaignId}`, {
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });

        const data = response.data;

        if (response.status === 200) {
            toast.success("Campaign deleted successfully");
        } else {
            throw new Error("Failed to delete campaign: " + data.error);
        }
    } catch (error) {
        throw new Error("Failed to delete campaign: " + error);
    }
};

export const createCampaign = async (campaignData) => {
    try {
        const response = await axios.post(`${getUrl("campaign_url")}/create`, campaignData, {
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });

        const data = response.data;

        if (response.status === 200) {
            return data.data;
        } else {
            throw new Error("Failed to create campaign: " + data.error);
        }
    } catch (error) {
        throw new Error("Failed to create campaign: " + error.message);
    }
};

export const updateCampaign = async (campaignId, campaignData) => {
    const apiUrl = `${getUrl("campaign_url")}/${campaignId}`;
    const headers = {
        "Content-Type": "application/json",
        "access-token": getAccessToken(),
    };

    try {
        const response = await axios.patch(apiUrl, campaignData, {
            headers: headers,
        });

        if (response.status !== 200) {
            throw new Error("Failed to update campaign");
        }

        const data = response.data;
        return data;
    } catch (error) {
        throw new Error("Failed to update campaign: " + error.message);
    }
};

export const SET_SELECTED_CAMPAIGN_ID = "SET_SELECTED_CAMPAIGN_ID";

export const setselectedCampaignId = (campaign_id) => {
    return {
        type: SET_SELECTED_CAMPAIGN_ID,
        payload: campaign_id,
    };
};
